export const SET_GRAPH_ELEMENT = 'SET_GRAPH_ELEMENT';
export const SET_BASIC_PROPERTY = 'SET_BASIC_PROPERTY';
export const SET_INIT = 'SET_INIT';